// © 2025 Ananda Kumar. All rights reserved.
// Unauthorized copying of this file, via any medium, is strictly prohibited.

export const environment = {
    appInsights: {
        instrumentationKey: 'f398cfd6-fbd6-4691-8a94-f27bef2bb790'
    },
    // apiUrl: 'https://arwedding-h7czdxh8gtfwcrfw.canadacentral-01.azurewebsites.net/api',
    apiUrl: 'https://kinvyt-api-dev.azurewebsites.net/api',
    // apiUrl: 'https://kinvyt.azurewebsites.net/api',
    // apiUrl: 'https://localhost:7111/api',
    clientKey: '062daa56-b20a-417a-966a-e3d69db5c0f0',
    apiEndpoints: {
        auth: {
            pinVerify: '/pin/verify',
            googleLogin: '/auth/google-login',
            logout: '/auth/signout',
            currentUser: '/auth/me'
        }
    }
};
